import React from 'react';
import { VignetteAUT, VignetteCZ, VignetteSLO, TollRoute, Flex, VignetteCH } from '@adac-mp/components';

interface IRenderProductIconProps {
	moduleTypeId?: number;
	supplierId?: number;
	tollClass?: string;
	className?: string;
	size?: string;
}

export const renderProductIcon = ({
	moduleTypeId,
	supplierId,
	tollClass,
	className,
	size,
}: IRenderProductIconProps) => {
	const getVignetteIcon = (id?: number) => {
		switch (id) {
			case 3:
				return <VignetteAUT className={`rounded-[6px] shrink-0 ${className}`} size={size} />;
			case 14:
				return <VignetteCH className={`rounded-[6px] shrink-0 ${className}`} size={size} />;
			case 6:
				return <VignetteCZ className={`rounded-[6px] shrink-0 ${className}`} size={size} />;
			case 7:
				return (
					<VignetteSLO category={tollClass} className={`rounded-[6px] shrink-0 ${className}`} size={size} />
				);
			default:
				return null;
		}
	};

	switch (moduleTypeId) {
		case 2:
			return getVignetteIcon(supplierId);
		case 3:
			return <TollRoute className={`rounded-[6px] shrink-0 ${className}`} size={size} />;
		case 4:
			return <Flex className={`rounded-[6px] shrink-0 ${className}`} size={size} />;
		default:
			return null;
	}
};
